export default __webpack_public_path__ + "static/media/video-1.59e75226.mp4";